export const SET_VIDEO_HISTORY_LIMIT = 'SET_VIDEO_HISTORY_LIMIT';
export const SET_VIDEO_HISTORY_OFFSET = 'SET_VIDEO_HISTORY_OFFSET';
export const SET_VIDEO_HISTORY = 'SET_VIDEO_HISTORY';
